import Vue from 'vue'

/**
 * @author Jose Luis Ruiz <jose.ruiz@jbge.com.mx>
 *
 * Send invoices to attach to Purchase Order
 * @param id Purcgase order id
 * @param PDF
 * @param XML
 * @return {Object}
 */

export default ({id: oc}, { id }) =>
  Vue.$http.delete(`purchase/order/${oc}/oc/files/${id}/`)


// WEBPACK FOOTER //
// ./src/services/purchase/purchaseOrder/deleteInvoiceToPurchaseOrder.js